import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import produce from "immer";

interface IColors {
  color: string,
  variable: string
}

export interface IUserObject {
  authToken: string | undefined,
  companytimezone: string,
  selectedLegalEntity: string,
  companyBannerImage: string,
  languageno: string,
  userFavorites: Array<IUserFavorite>,
  defaultPage: string,
  companyBannerHidden: boolean,
  hidden: Array<string>,
  user: {
    username: string | undefined;
    name: string | undefined;
    email: string | undefined;
    usercategoryno: string | undefined;
    userphoto: string | undefined;
    employeeno: string | undefined;
    joiningdate: string;
    allowmobile: boolean;
    resetpasswordonlogin: boolean;
    peoplenestadmin: boolean;
  },
  clientLanguage: Array<{
    languageno: string;
    languagenostxt: string;
    isdefault: boolean;
  }>,
  UserLegalEntity: Array<{
    legalentityno: string,
    legalentitystxt: string,
    isdefault: boolean,
    logoimage: string
  }>,
  CompanyDataFormat: Array<{
    fielddataformatno: string,
    fielddataformatconstant: string,
    fielddataformat: string,
    fielddataformatmasking: string,
    legalentityno: string,
    fielddataprocesscode: string,
    processcode: string
  }>,
  SystemLanguages: Array<{
    prid: string,
    objectno: string,
    objectlabel: string,
    objectdefinition: string,
    languageno: string,
  }>,
  CompanyLedgerInfo: {
    legalentitycalendarno: string | null,
    accountchartno: string | null,
    localcurrencyno: string | null,
    reportingcurrencyno: string | null,
    localexchangecategoryno: string | null,
    reportingexchangecategoryno: string | null,
  },
}

export interface IUserLogin {
  username: string;
  password: string;
  languageno: string
  clientno: string,
  redirectUrl?: string;
}

export interface IUserForgotPassword {
  email: string;
  clientno: string;
}

export interface IUserResetPassword {
  email: string;
  password: string;
  token: string;
}

interface IUserFavorite {
  objectcontrollerno: string;
  objectcontrollerstxt: string;
  applicationobjecttype: string;
}

const initialState: IUserObject = {
  authToken: undefined,
  companytimezone: "",
  selectedLegalEntity: "",
  companyBannerImage: "",
  languageno: "",
  clientLanguage: [],
  userFavorites: [],
  UserLegalEntity: [],
  CompanyDataFormat: [],
  SystemLanguages: [],
  CompanyLedgerInfo: {
    accountchartno: null,
    legalentitycalendarno: null,
    localcurrencyno: null,
    localexchangecategoryno: null,
    reportingcurrencyno: null,
    reportingexchangecategoryno: null
  },
  user: {
    username: undefined,
    name: undefined,
    email: undefined,
    usercategoryno: undefined,
    userphoto: undefined,
    employeeno: undefined,
    allowmobile: false,
    joiningdate: "1900-01-01T00:00:00",
    resetpasswordonlogin: false,
    peoplenestadmin: false
  },
  defaultPage: "",
  hidden: [],
  companyBannerHidden: false
}

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    loginUser(state, action: PayloadAction<IUserLogin>) { },
    forgotUserPassword(state, action: PayloadAction<IUserForgotPassword>) { },
    resetUserPassword(state, action: PayloadAction<IUserResetPassword>) { },
    logoutUser() { },
    getLoginBasicData() { },
    getUserSpecificDetail() { },
    setLoginBasicData(state, action) {
      const payload = action.payload;
      return { ...state, ...payload };
    },
    setUserObject(state, action) {
      const payload = action.payload;
      return { ...state, ...payload };
    },
    addUserFavorite(state, action: PayloadAction<IUserFavorite>) {
      const { applicationobjecttype, objectcontrollerstxt, objectcontrollerno } = action.payload;

      return produce(state, (draftState) => {
        const alreadyInFavorite = draftState.userFavorites.findIndex(x => x.objectcontrollerno == objectcontrollerno);

        if (alreadyInFavorite > -1) {
          draftState.userFavorites.splice(alreadyInFavorite, 1);
        }
        else {
          draftState.userFavorites.push({ objectcontrollerno, applicationobjecttype, objectcontrollerstxt })
        }
      })
    }
  }
});

export const { loginUser, forgotUserPassword, resetUserPassword, addUserFavorite, logoutUser, getLoginBasicData, setLoginBasicData, setUserObject, getUserSpecificDetail } = userSlice.actions;

export default userSlice.reducer;
